module.exports = function() {
  return new Worker(__webpack_public_path__ + "ecaa8e763fe00e118885.worker.js");
};